export enum FirebaseAction {
  resetPassword,
  recoverEmail,
  verifyEmail
}
